import { render, staticRenderFns } from "./Behaviours.vue?vue&type=template&id=f2e6b386&scoped=true&"
import script from "./Behaviours.vue?vue&type=script&lang=js&"
export * from "./Behaviours.vue?vue&type=script&lang=js&"
import style0 from "./Behaviours.vue?vue&type=style&index=0&id=f2e6b386&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e6b386",
  null
  
)

export default component.exports